import { ChartProps } from '@features/powerpoint';
import { chartColors, defaultChartOptions } from './default-chart-options';
import { DemographicProfileChartConfiguration } from '../demographic-profile';

const chartSpecificOptions = [
  {
    barDir: 'col',
    h: 1.64,
    w: 2.4,
    x: 0.98,
    y: 2.1,
    catAxisLabelFontSize: 7,
  },
  {
    barDir: 'col',
    h: 1.64,
    w: 2.4,
    x: 4.02,
    y: 2.1,
    catAxisLabelFontSize: 7,
  },
  {
    barDir: 'col',
    h: 1.64,
    w: 2.4,
    x: 7.03,
    y: 2.1,
    catAxisLabelFontSize: 7,
  },
  {
    barDir: 'col',
    h: 1.64,
    w: 2.4,
    x: 10.05,
    y: 2.1,
    catAxisLabelFontSize: 7,
  },
  {
    barDir: 'col',
    h: 1.66,
    w: 2.83,
    x: 0.76,
    y: 4.22,
    catAxisLabelFontSize: 7,
  },
  {
    barDir: 'col',
    h: 1.64,
    w: 2.4,
    x: 4.02,
    y: 4.22,

    catAxisLabelFontSize: 7,
  },
  {
    barDir: 'bar',
    h: 1.72,
    w: 2.5,
    x: 6.98,
    y: 4.18,

    catAxisLabelFontSize: 6,
  },
  {
    barDir: 'bar',
    h: 1.72,
    w: 2.5,
    x: 10,
    y: 4.22,

    catAxisLabelFontSize: 6,
  },
] as const satisfies readonly ChartProps['options'][];

type ChartsOptions = {
  chartConfig: DemographicProfileChartConfiguration;
};

export const charts = (options: ChartsOptions): ChartProps[] =>
  options.chartConfig.map((profile, chartIndex): ChartProps => {
    const labels = profile.stats.map(stat => stat.name.toUpperCase());
    const values = profile.stats.map(stat => stat.value);
    const chartOptions = chartSpecificOptions[chartIndex];

    return {
      type: 'bar',
      data: [
        {
          name: 'Values',
          labels,
          values,
        },
      ],
      options: {
        ...chartOptions,
        ...defaultChartOptions,
        chartColors: [chartColors[chartIndex % 2]],
        x: chartOptions.x,
      },
    };
  });
